import { webAPIUrl } from "./AppSettings";
import userManager from "./userManager";



export interface HttpRequest<REQUEST_BODY> {
    path: string;
    method?: string;
    body?: REQUEST_BODY;
}
export interface HttpResponse<RESPONSE_BODY> extends Response {
    parsedBody?: RESPONSE_BODY;
}

export const http = <REQUEST_BODY, RESPONSE_BODY>(
    config: HttpRequest<REQUEST_BODY>,
): Promise<HttpResponse<RESPONSE_BODY>> => {
    return new Promise(async (resolve, reject) => {
        var user = await userManager.getUser();
        var idToken = "";
        if (user && user.id_token) {
            idToken = user.id_token;
        }

        const request = new Request(`${webAPIUrl}${config.path}`, {
            method: config.method || "get",
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store',
                'Pragma': 'no-cache',
                'X-Content-Type-Options': 'nosniff',
                'X-Frame-Options': 'SAMEORIGIN',
                'frame-ancestors': 'self'
            },
            body: config.body ? JSON.stringify(config.body) : undefined,
        });
        if (idToken != "") {
            request.headers.set("authorization", `${idToken}`);
        }
        let response: HttpResponse<RESPONSE_BODY>;
        fetch(request)
            .then(res => {
                response = res;
                if (res.headers.get("Content-Type") || "".indexOf("json") > 0) {
                    return res.json();
                } else {
                    resolve(response);
                }
            })
            .then(body => {
                if (response.ok) {
                    response.parsedBody = body;
                    resolve(response);
                } else {
                    let rejectValue: any = {
                        code: body.code,
                        stack: body.stack,
                        message: body.message,
                        name: body.name
                    };
                    reject(rejectValue);
                }
            })
            .catch(err => {
                reject(err);
            });
    });
};

export default http;
